import React from 'react';
import { SourceItem } from '../../semantic_search.types.js';
import { PdfPreview } from '../../pdf_preview.js';
import { Config } from '../../../core/config/config.js';
import TabPanel, { TabPanelTypes } from 'devextreme-react/tab-panel';
import { useSemanticSearchStore } from '../../store/SemanticSearchContext.js';
import { FAIcon } from '../../../core/components/faIcon.js';
import { PREVIEW_TAB_KEY } from '../../store/semantic_search.store.types.js';
import { OptionChangedEvent } from 'devextreme/ui/tab_panel.js';
import { EmailPreview } from './EmailPreview';
class TicketView extends React.Component<{ problemnr: number }, any>{
    render() {
        const url = Config.baseUrl + `Procedure/Edit?id=${this.props.problemnr}&nonorth=true`;
        return <div style={{ flex: 1, height: "100%", width: "100%", display: "flex", flexDirection: "column" }} >
            <iframe style={{ flex: 1 }} key={this.props.problemnr} src={url}></iframe>
        </div>
    }
}

class DocumentaionView extends React.Component<{ url: string }, any>{
    render() {
        return <div style={{ flex: 1, height: "100%", width: "100%", display: "flex", margin: "5px", flexDirection: "column" }} >
            <iframe style={{ flex: 1 }} key={this.props.url} src={this.props.url}></iframe>
        </div>
    }
}

const SourceContent: React.FC<{ source: SourceItem | null; textToHighlight?: string[] }> = ({ source, textToHighlight }) => {
    if (!source) {
        return (
            <div style={{ color: "lightgray", display: "flex", alignItems: "center", justifyContent: "center", flex: 1 }}>
                Kein Dokument ausgewählt
            </div>
        );
    }

    switch (source.Type) {
        case 'pdf':
            return (
                <PdfPreview
                    key={source.IsGuid}
                    titel={source.Title}
                    page={source.Page}
                    dokuId={source.IsGuid}
                    textToHighlight={textToHighlight}
                />
            );
        case 'ticket':
            return <TicketView problemnr={source.ProblemNr} />;
        case 'email':
            return <EmailPreview source={source} />;
        case 'documentation':
            return <DocumentaionView url={source.Url} />;
        default:
            return (
                <div style={{ color: "lightgray", display: "flex", alignItems: "center", justifyContent: "center", flex: 1 }}>
                    Vorschau für diesen Quellentyp nicht verfügbar.
                </div>
            );
    }
};

interface SourcePreviewProps {
    textToHighlight?: string[];
}

export const SourcePreview: React.FC<SourcePreviewProps> = ({ textToHighlight }) => {
    const favorites = useSemanticSearchStore(state => state.favorites);
    const selectedTabKey = useSemanticSearchStore(state => state.selectedTabKey);
    const selectedListItem = useSemanticSearchStore(state => state.selectedListItem);
    const activePreviewItem = useSemanticSearchStore(state => state.activePreviewItem);
    const setSelectedTabKey = useSemanticSearchStore(state => state.setSelectedTabKey);
    const toggleFavorite = useSemanticSearchStore(state => state.toggleFavorite);

    const allTabs = [
        // Der "Vorschau"-Tab-Eintrag verwendet das `selectedListItem`, um seinen Titel und sein Symbol zu definieren.
        { key: PREVIEW_TAB_KEY, title: 'Vorschau', sourceData: selectedListItem, isFavorite: false },
        ...favorites.map(fav => ({ key: fav.SourceId, title: fav.Title, sourceData: fav, isFavorite: true }))
    ];

    const selectedIndex = allTabs.findIndex(tab => tab.key === selectedTabKey);
    const actualSelectedIndex = selectedIndex === -1 ? 0 : selectedIndex;

    const handleTabClose = (item: SourceItem) => {
        toggleFavorite(item);
    };

    const tabTitleRender = (tab: { key: string, title: string, sourceData: SourceItem, isFavorite: boolean }) => {
        let icon;
        const type = tab.sourceData?.Type;
        const cleanTitle = tab.title.replace(/\|\|\|HIGHLIGHT\|\|\||\|\|\|ENDHIGHLIGHT\|\|\|/g, '');

        if (tab.isFavorite) {
            if(type === 'ticket') icon = <FAIcon name="exclamation-square" prefix="fal" />;
            else if (type === 'email') icon = <FAIcon name="envelope" prefix="fal" />;
        } else {
            icon = <FAIcon name="eye" prefix="fal" />;
        }

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} title={cleanTitle}>
                {icon}
                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '150px' }}>
                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {cleanTitle}
                    </span>
                    {type === 'ticket' && (
                        <span style={{ fontSize: '0.8rem', color: '#777', whiteSpace: 'nowrap' }}>
                            Ticket #{(tab.sourceData as any).ProblemNr}
                        </span>
                    )}
                     {type === 'email' && (
                        <span style={{ fontSize: '0.8rem', color: '#777', whiteSpace: 'nowrap' }}>
                            E-Mail
                        </span>
                    )}
                </div>
                {tab.isFavorite && (
                    <i
                        className="dx-icon dx-icon-close"
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleTabClose(tab.sourceData);
                        }}
                    />
                )}
            </div>
        );
    };

    const onSelectionChanged = (args:OptionChangedEvent) => {
        if (args.name === 'selectedIndex') {
            const newKey = allTabs[args.value]?.key;
            if (newKey && newKey !== selectedTabKey) {
                setSelectedTabKey(newKey);
            }
        }
    };
    
    if (!activePreviewItem && favorites.length === 0) {
        return (
            <div style={{ color: "lightgray", display: "flex", alignItems: "center", justifyContent: "center", flex: 1 }}>
                Kein Dokument ausgewählt
            </div>
        );
    }
    
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
            <TabPanel
                dataSource={allTabs}
                selectedIndex={actualSelectedIndex}
                onOptionChanged={onSelectionChanged}
                itemTitleRender={tabTitleRender}
                itemRender={() => <div />} // Wichtig: Das Template ist leer, wir rendern den Inhalt manuell
                height="auto"
                animationEnabled={true}
                scrollingEnabled={true}
                showNavButtons={true}
            />
            <div style={{ flex: 1, position: 'relative' }}>
                {allTabs.map((tab, index) => (
                    <div
                        key={tab.key}
                        style={{
                            display: index === actualSelectedIndex ? 'flex' : 'none',
                            flexDirection: 'column',
                            height: '100%',
                            width: '100%',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                        }}
                    >
                        <SourceContent 
                            source={tab.sourceData} 
                            textToHighlight={tab.key === PREVIEW_TAB_KEY ? textToHighlight : undefined}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};